import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateExclamation } from "@fortawesome/pro-regular-svg-icons";
import { AxiosResponse } from "axios";
import { Button, LoadPanel,LoadIndicator } from "devextreme-react";
import gridUtils from "../../grid/GridUtilities";
import sharedUtils from "../../grid/sharedUtilities";
import PaymentService from "../../../services/PaymentService";

interface STAInvoicePaymentProps {
    data: any;
    onRefresh?: (flag:boolean) => void;
    type: string;
    handleErr : (respMessage:string)=>void;
    handleSuccessStaCall:(respMessage:any)=>void;
    disableRetry?: boolean;
}

interface STAInvoicePaymentState {
    loadPanelVisible: boolean;
}

class STAInvoicePayment extends React.Component<STAInvoicePaymentProps> {
    state: STAInvoicePaymentState;
    Service: PaymentService;
    gridUtils: gridUtils;
    sharedUtils: sharedUtils;
    constructor(props: STAInvoicePaymentProps) {
        super(props);
        this.state = {
            loadPanelVisible: false,
        };
        this.Service = new PaymentService();
        this.gridUtils = new gridUtils();
        this.sharedUtils = new sharedUtils();
    }

    onRegenerateClick = (event: any) => {
        event.event?.stopPropagation();
        const row = this.props.data.data;
        const paymentId = row.paymentId || '';
        const paymentCycleId = row.paymentCycleId || '';
        const isFasterPay = row.fasterPay === true;

        this.setState({ loadPanelVisible: true }, () => {
            const apiCall = isFasterPay
                ? this.Service.sendFasterPayPurchaseInvoice(paymentId)                 // Faster Pay
                : this.Service.sendPurchaseInvoicePaymnetDates(                        // Payment Cycle
                    paymentCycleId, paymentId, this.props.type === "payment");

            apiCall.then(this.handleSuccess).catch(this.handleError);
        });
    };

    handleSuccess = (response: AxiosResponse<any>) => {
                this.setState({
                    loadPanelVisible: false
                },()=>{
                this.props.handleSuccessStaCall(Array.isArray(response.data) ? response.data[0] : response.data);

                });
    };

    handleError = (error: any) => {
    this.setState({ loadPanelVisible: false });

    let respMessage = "";
    try {
        const data = error?.response?.data.errors;
        if (Array.isArray(data)) {
            respMessage = data[0]?.ErrorMessage || data[0]?.errorMessage || "Unknown error occurred.";
        }
        else if (data && typeof data === "object") {
            console.warn("Server Error Object:", data);
            respMessage = data.data[0].errorMessage;
        }
        else {
            respMessage = error?.message || "Unknown error occurred.";
        }
    } catch (ex) {
        respMessage = "An unexpected error occurred.";
    }

    this.props.handleErr(respMessage);
};

    /**
     * Renders the retry button or loader for STA generation.
     */
    renderInvoiceRegenerateButton = () =>{ 
        let showRegenerate = true;  //show regenerate in all cases
        const isRetryDisabled = !!this.props.disableRetry;
        if (showRegenerate) {
            return (
                <>
                    {!this.state.loadPanelVisible?
                        <Button className="btn icon-btn btn-file-downloader w-100" disabled={isRetryDisabled} onClick={(e) => this.onRegenerateClick(e)}>
                            <FontAwesomeIcon icon={faRotateExclamation} />
                        </Button>
                        :
                        <LoadIndicator
                            style={{marginLeft:"40%"}}
                            id="load-indicator"
                            height={20}
                            width={20}
                            visible={this.state.loadPanelVisible}
                        />
                    }
                </>
            );
        }
    }

    render() {
        return (
            <>
            <div className="d-flex justify-content-between align-items-center w-100">
                {this.props.data.data.sentToAccountsDateInvoice && this.props.type==="invoice"?(
                    <div >{this.props.data.data.sentToAccountsDateInvoice}</div>
                ):this.props.data.data.sentToAccountsDatePayment && this.props.type==="payment"?(
                    <div >{this.props.data.data.sentToAccountsDatePayment}</div>
                ):(
                <>
                <div style={{ width: "100%" }}>{this.renderInvoiceRegenerateButton()}</div>
                </>
                )}
            </div>
            </>
        );
    }
}

export default STAInvoicePayment;
